export const TRUCK_HD_STYLES = [
  {
    slug: "ts1",
    name: "TS1",
    img: "/assets/truckhd-style-1.jpg",
    blurb:
      "TS1 is like a fresh pair of clean white sneakers for your truck. Sharp, and effortlessly making the whole build look better, while still built to work, tow, and take daily abuse.",
    specs: [
      "Forged aerospace-grade 6061-T6 aluminum",
      "Designed for half-ton and HD trucks",
      "Custom widths, offsets, and hub bores",
      "Optimized for towing and daily abuse",
      "Multiple finish options available",
      "Lifetime structural warranty*",
    ],
  },
  {
    slug: "ts2",
    name: "TS2",
    img: "/assets/truckhd-style-2.jpg",
    blurb:
      "TS2 is built for clean luxury trucks and SUVs with a tailored, suit-and-tie stance. Bold split spokes and deep profiles add presence without screaming, making it perfect for Escalades, Tahoes, and modern F-150 builds that prioritize style, strength, and refinement.",
    specs: [
      "Forged aerospace-grade 6061-T6 aluminum",
      "Lifted-truck offset geometry",
      "Deep profile where suspension allows",
      "Built around tire size and ride height",
      "Custom finishes and accents available",
      "Lifetime structural warranty*",
    ],
  },
{
    slug: "ts3",
    name: "TS3",
    img: "/assets/truckhd-style-3.jpg",
    blurb:
      "TS3 is for trucks and SUVs that want a clean, modern look with real presence—balanced spokes, smooth surfaces, and a strong silhouette that looks just as right on a street-driven Tahoe as it does on a leveled F-150. Subtle, confident, and built to handle real use.",
    specs: [
      "Forged aerospace-grade 6061-T6 aluminum",
      "Lifted-truck offset geometry",
      "Deep profile where suspension allows",
      "Built around tire size and ride height",
      "Custom finishes and accents available",
      "Lifetime structural warranty*",
    ],
  },
{
    slug: "ts4",
    name: "TS4",
    img: "/assets/truckhd-style-4.jpg",
    blurb:
      "TS4 is the boldest design in the Truck HD lineup—an intricate forged mesh built for high-end trucks and SUVs that want maximum visual impact without sacrificing strength, load rating, or drivability. Luxury presence with real backbone.",
    specs: [
      "Forged aerospace-grade 6061-T6 aluminum",
      "Lifted-truck offset geometry",
      "Deep profile where suspension allows",
      "Built around tire size and ride height",
      "Custom finishes and accents available",
      "Lifetime structural warranty*",
    ],
  },
];
